import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { Optional, Union } from "@/__main__/data-model.mjs";
import { cardBrandModel } from "@/feature-wallet/models/card-brand.mjs";
import { paymentProviderTypeModel } from "@/feature-wallet/models/payment-method-provider.mjs";

export const paymentMethodTypeModel = Union([
  "paypal_account",
  "card",
  "unknown",
]);

export type PaymentMethodType = FromModel<typeof paymentMethodTypeModel>;

/**
 * The base model for any payment method. Contains only the fields that are common to all
 * payment methods.
 */
export const basePaymentMethodModel = {
  id: String,
  type: paymentMethodTypeModel,
  createdAt: Date,

  providerType: paymentProviderTypeModel,
} satisfies ModelDefinition;

/**
 * The combined model for any particular payment method. This should generally not be used
 * directly, since it contains all possible fields for every payment method type, even if
 * they're irrelevant.
 */
export const anyPaymentMethodModel = {
  ...basePaymentMethodModel,

  cardBrand: Optional(cardBrandModel),
  cardCountry: Optional(String),
  cardExpiryMonth: Optional(Number),
  cardExpiryYear: Optional(Number),
  cardLast4: Optional(String),
  billingPostalCode: Optional(String),
} satisfies ModelDefinition;

export const anyUserPaymentMethodsModel = {
  defaultPaymentMethodId: Optional(String),
  paymentMethods: [anyPaymentMethodModel],
  providerType: paymentProviderTypeModel,
} satisfies ModelDefinition;
